import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import useTranslations from '../../../i18n/useTranslations'
import ModalLayout from '../layout'
import useStyles from './styles'

const NormativeModal = ({ isOpen, onClose }) => {
  const t = useTranslations()

  const classes = useStyles()

  return (
    <ModalLayout
    isOpen={isOpen}
    closeButton={true}
    wide={500}
    title={t('shipping-send-form:customs:custom-normative')}
    content={
      <>
        <Typography>
          {t('shipping-send-form:customs:custom-normative-text-1')}
        </Typography>
        <Box className={classes.pointSection}>
          <Typography
            fontWeight={'bold'}
            className={classes.textSection}
          >
            {t(
              'shipping-send-form:customs:custom-normative-text-declaration',
            )}
          </Typography>
          <Typography>
            {t(
              'shipping-send-form:customs:custom-normative-text-declaration-body',
            )}
          </Typography>
          <Typography
            fontWeight={'bold'}
            className={classes.textSection}
          >
            {t(
              'shipping-send-form:customs:custom-normative-text-cities',
            )}
          </Typography>
          <Typography>
            {t(
              'shipping-send-form:customs:custom-normative-text-cities-body',
            )}
          </Typography>
          <Typography
            fontWeight={'bold'}
            className={classes.textSection}
          >
            {t(
              'shipping-send-form:customs:custom-normative-text-waste',
            )}
          </Typography>
          <Typography>
            {t(
              'shipping-send-form:customs:custom-normative-text-waste-body',
            )}
          </Typography>
          <Typography
            fontWeight={'bold'}
            className={classes.textSection}
          >
            {t(
              'shipping-send-form:customs:custom-normative-text-exportacion',
            )}
          </Typography>
          <Typography>
            {t(
              'shipping-send-form:customs:custom-normative-text-exportacion-body',
            )}
          </Typography>
        </Box>
      </>
    }
    onClose={() => {if(onClose) onClose()}}
  />
  )
}

NormativeModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}

export default NormativeModal
